// Generated by CoffeeScript 2.7.0
require('trunks/vue/share/core_ext/index.js');

require('./directives/index.js');
